export const appName = "VertiFlex";
